/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
export interface IData {
    data_timestamp: string[];
    data_values: number[];
}
export function format_chart_data(data: IData): number[][] {
    const {
        data_timestamp,
        data_values
    } = data;
    return data_timestamp.reduceRight((memo: number[][], item: string, index: number): number[][] => {
        memo.push([
            new Date(item).getTime(),
            data_values[index]
        ]);
        return memo;
    }, []);
}

export function getPercetage(total: number, value: number): number {
    return (100 * value) / total;
}
